/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { QuoteTemplateShareButton_QuoteTemplateFragmentDoc } from './buttons/QuoteTemplateShareButton.generated.js';
import { QuoteTemplateSubscribeButton_QuoteTemplateFragmentDoc } from './buttons/QuoteTemplateSubscribeButton.generated.js';
import { QuoteTemplateUnsubscribeButton_QuoteTemplateFragmentDoc } from './buttons/QuoteTemplateUnsubscribeButton.generated.js';
import { QuoteTemplateUpdateSubscribedVersionButton_QuoteTemplateFragmentDoc } from './buttons/QuoteTemplateUpdateSubscribedVersionButton.generated.js';
export type TemplateQuoteAction_QuoteTemplateFragment = { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, latestPublishedVersionNumber?: number | null, owningSystemOrganisationId: string, hasAnyPublishedVersion: boolean, accessType: Types.TemplateAccessType, containsUnpublishedChanged: boolean, usedInOtherTemplates: boolean, hasOverridesDefined: boolean, templateSharing?: { __typename: 'TemplateSharing', id: string, latestSharedVersionNumber: number, sharedPublicly: boolean, templateId: string, subscribedToTemplate?: { __typename: 'TemplateSubscription', subscribedVersionNumber: number, updateAvailable: boolean } | null, sharedWithOrganisations: Array<{ __typename: 'Company', id: string, title: string, logo: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } }> } | null };

export const TemplateQuoteAction_QuoteTemplateFragmentDoc = gql`
    fragment TemplateQuoteAction_QuoteTemplate on QuoteTemplate {
  id
  resolvedAsReadModelVersionNumber
  latestPublishedVersionNumber
  owningSystemOrganisationId
  hasAnyPublishedVersion
  accessType
  containsUnpublishedChanged
  templateSharing {
    id
    latestSharedVersionNumber
    sharedPublicly
    subscribedToTemplate {
      subscribedVersionNumber
      updateAvailable
    }
  }
  ...QuoteTemplateShareButton_QuoteTemplate
  ...QuoteTemplateSubscribeButton_QuoteTemplate
  ...QuoteTemplateUnsubscribeButton_QuoteTemplate
  ...QuoteTemplateUpdateSubscribedVersionButton_QuoteTemplate
}
    ${QuoteTemplateShareButton_QuoteTemplateFragmentDoc}
${QuoteTemplateSubscribeButton_QuoteTemplateFragmentDoc}
${QuoteTemplateUnsubscribeButton_QuoteTemplateFragmentDoc}
${QuoteTemplateUpdateSubscribedVersionButton_QuoteTemplateFragmentDoc}`;